import { Injectable } from '@angular/core';
import { LinkClickEvent } from '../events/link-click-event';
import { AnalyticsEventProvider } from './analytics-event-provider.service';

export interface LinkClickEventArgs {
  element?: HTMLElement;
  customText?: string;
  fieldName?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticsLinkClickProvider extends AnalyticsEventProvider<LinkClickEvent> {
  createAndPush(args: LinkClickEventArgs): void {
    const clickText = args.customText ?? this.getElementText(args.element);
    if (!clickText) return;

    this.push(
      new LinkClickEvent({
        click_text: clickText,
        field_name: args.fieldName,
      }),
    );
  }

  private getElementText(element: HTMLElement | undefined): string | undefined {
    if (!element) return undefined;

    const ariaLabel = element.getAttribute('aria-label')?.trim();
    if (ariaLabel) return ariaLabel;

    const title = element.getAttribute('title')?.trim();
    if (title) return title;

    const text = (element.innerText || element.textContent)?.replace(/\s+/g, ' ').trim();
    return text || undefined;
  }
}
